<template>
  <div id="review-order-index-loading" class="vs-con-loading__container">
    <review-order-filter
      :clients="clients"
      :status="reviewStatus"
      v-model="params"
      @search="handleFilter"
    />

    <div class="vx-row">
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('ready_review')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="FileTextIcon"
            title="Ready for review"
            :statistic="cards.ready_review"
            color="#9B59B6"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('reviewing')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="BellIcon"
            title="Reviewing"
            :statistic="cards.reviewing"
            color="#FF9F43"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('rejected')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="XCircleIcon"
            title="Rejected"
            :statistic="cards.rejected"
            color="#BC1300"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('approved')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="CheckCircleIcon"
            title="Approved"
            :statistic="cards.approved"
            color="#28C76F"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('review_origin')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="MapPinIcon"
            title="Review at Origin"
            :statistic="cards.review_origin"
            color="#7F8C8D"
          />
        </div>
      </div>
      <div class="vx-col md:w-1/6 mt-5">
        <div
          class="vx-col w-full"
          @click="clickCard('shipped')"
          style="cursor: pointer"
        >
          <statistics-card
            class="mb-base"
            icon="TruckIcon"
            title="Shipped"
            statistic="-"
            color="#D35400"
          />
        </div>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col md:w-1/3 mt-5" v-if="false">
        <div class="vx-row">
          <div
            class="vx-col w-full"
            @click="clickCard('ready_review')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="FileTextIcon"
              icon-right
              :statistic="cards.ready_review"
              statisticTitle="Ready for review"
              :hideChart="true"
              color="info"
              svgClasses="cursor-pointer"
              style="height: 75px"
            />
          </div>
          <div
            class="vx-col w-full mt-2"
            @click="clickCard('reviewing')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="BellIcon"
              icon-right
              :statistic="cards.reviewing"
              statisticTitle="Reviewing"
              :hideChart="true"
              color="warning"
              style="height: 75px; padding-bottom: 15px"
            />
          </div>
          <div
            class="vx-col w-full mt-2"
            @click="clickCard('rejected')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="ThumbsDownIcon"
              icon-right
              :statistic="cards.rejected"
              statisticTitle="Rejected"
              :hideChart="true"
              color="danger"
              style="height: 75px"
            />
          </div>
          <div
            class="vx-col w-full mt-2"
            @click="clickCard('approved')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="CheckCircleIcon"
              icon-right
              :statistic="cards.approved"
              statisticTitle="Approved"
              :hideChart="true"
              color="success"
              style="height: 75px"
            />
          </div>
          <div
            class="vx-col w-full mt-2"
            @click="clickCard('review_origin')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="MapPinIcon"
              icon-right
              :statistic="cards.review_origin"
              statisticTitle="Review at Origin"
              :hideChart="true"
              color="light"
              style="height: 75px"
            />
          </div>
          <div
            class="vx-col w-full mt-2"
            @click="clickCard('shipped')"
            style="cursor: pointer"
          >
            <statistics-card-line
              icon="TruckIcon"
              icon-right
              :statistic="''"
              statisticTitle="Shipped"
              :hideChart="true"
              color="success"
              style="height: 75px"
            />
          </div>
        </div>
      </div>
      <div class="vx-col md:w-2/3 mt-5">
        <vs-card class="custom-card-h-ro">
          <div slot="header">
            <vs-row :style="{ borderBottom: '#bec0c2 solid 2px' }">
              <vs-col>
                <h2 @click="clickTitle" class="title-card-clickeable">
                  {{ $tc('review_order', 2) | capitalize }}
                  {{ $t('by_client') | capitalize }}
                </h2>
              </vs-col>
              <!--  <vs-col vs-offset="4" vs-w="1" vs-type="flex" vs-justify="flex-end" vs-align="center">
                  <vx-tooltip
                    delay="0.5s"
                    :text="$tc('type',2)|capitalize"
                    tooltipPosition="top"
                  >
                    <feather-icon
                      icon="PackageIcon"
                      :style="{color: lastIconClicked=='types'?'#ba0000':'#5d6063'}"
                      svgClasses="hover:text-primary cursor-pointer"
                      @click="clickTypeIcon"
                    />
                  </vx-tooltip>
                </vs-col>
                <vs-col vs-w="1" vs-type="flex" vs-justify="flex-end" vs-align="center">
                  <vx-tooltip
                    delay="0.5s"
                    :text="$t('status')|capitalize"
                    tooltipPosition="top"
                  >
                    <feather-icon
                      icon="PieChartIcon"
                      :style="{color: lastIconClicked=='types'?'#5d6063':'#ba0000'}"
                      svgClasses="hover:text-primary cursor-pointer"
                      @click="clickStatusIcon"
                    />
                  </vx-tooltip>
                </vs-col> -->
            </vs-row>
          </div>
          <review-order-stacked-column
            :chartId="'review-order-bar'"
            :height="'380'"
            @clickStackedSection="clickStackedSection"
          >
          </review-order-stacked-column>
        </vs-card>
      </div>
      <div class="vx-col md:w-1/3 mt-5">
        <vs-card class="custom-card-h-ro">
          <div slot="header">
            <vs-row :style="{ borderBottom: '#bec0c2 solid 2px' }">
              <vs-col>
                <h2 @click="clickTitle" class="title-card-clickeable">
                  {{ $tc('review_order', 2) | capitalize }}
                  {{ $t('by_status') | capitalize }}
                </h2>
              </vs-col>
            </vs-row>
          </div>
          <review-order-donut
            :chartId="'review-order-donut'"
            :height="'365'"
            :series="seriesDonut"
            @clickDonutSection="clickReviewOrderDonut"
          />
        </vs-card>
      </div>
    </div>
    <div class="vx-row mt-5">
      <div class="vx-col md:w-1/3"></div>
    </div>

    <vs-card>
      <div id="review-order-table-loading" class="vs-con-loading__container">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <review-order-table
              :data="list"
              @loadMore="loadMore"
              @search="handleSearch"
              @sort="sort"
              @add="redirectAddReviewOrder"
            />
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import ReviewOrderTable from './components/ReviewOrderTable'
import ReviewOrderStackedColumn from './components/ReviewOrderStackedColumn'
import ReviewOrderDonut from './components/ReviewOrderDonut'
import ReviewOrderFilter from './components/ReviewOrderFilter'
import AddButton from '@/views/components/buttons/AddButton'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import loading from '@/mixins/Loading'
import reviewOrder from '@/http/requests/reviewOrder'
import client from '@/http/requests/client'
import StatisticsCard from '@/views/modules/import_export/review_order/components/StatisticsCard.vue'

export default {
  components: {
    DonutChart,
    ReviewOrderDonut,
    ReviewOrderTable,
    ReviewOrderFilter,
    AddButton,
    ReviewOrderStackedColumn,
    StatisticsCardLine,
    StatisticsCard
  },
  data: () => ({
    lastPage: '',
    params: {
      client: [],
      status: ['1', '2', '4', '5', '6', '7', '8', '9', '11'],
    },
    filterBar: 'status',
    search: '',
    page: 1,
    list: [],
    clients: [],
    reviewStatus: [],
    seriesDonut: [],
    lastIconClicked: 'status',
    cards: {
      ready_review: 0,
      reviewing: 0,
      rejected: 0,
      approved: 0,
      review_origin: 0,
    },
    idsCharts: {
      status: [],
      clients: [],
      types: [],
    },
  }),
  methods: {
    getData() {
      this.openLoading('review-order-index-loading')
      let data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      reviewOrder
        .reviewList(data)
        .then((res) => {
          this.lastPage = res.data.last_page
          if (data.page > 1) {
            this.list.push(...res.data.data)
          } else {
            this.list = [...res.data.data]
          }
          this.closeLoading('review-order-index-loading')
        })
        .catch((res) => {
          this.closeLoading('review-order-index-loading')
        })
    },
    init() {
      this.getClients()
      this.getReviewOrderStatus()
      this.getCardsInfo()
      this.loadReviewOrderDonut()
      this.loadBar()
      this.getData()
    },
    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },
    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.page = 1
      this.getData()
    },
    getClients() {
      client.list().then((response) => {
        this.clients = [...response.data.clients]
      })
    },
    getReviewOrderStatus() {
      reviewOrder.getReviewStatus().then((res) => {
        this.reviewStatus = [...res.data.status]
      })
    },
    loadReviewOrderDonut() {
      reviewOrder
        .reviewDonutPlot(this.params)
        .then((res) => {
          let labels = []
          let series = []
          let colors = []
          let donutInfo = res.data.items
          donutInfo.forEach((item, index) => {
            labels[index] = item.label
            series[index] = Number(item.total)
            colors[index] = item.color
            this.idsCharts.status[index] = {
              label: item.label,
              id: item.id,
            }
          })
          ApexCharts.exec(
            'review-order-donut',
            'updateOptions',
            {
              fill: {
                colors: colors,
              },
              legend: {
                markers: {
                  fillColors: colors,
                },
              },
              labels: labels,
              series: series,
            },
            false,
            true
          )
        })
        .catch((err) => {
          console.log(err)
        })
    },
    loadBar() {
      reviewOrder
        .reviewBarPlot(this.filterBar, this.params)
        .then((res) => {
          let index_name = 0
          let index_code = 0
          let barInfo = res.data.items
          let arrayColors = []
          let categories = []
          let series = [
            {
              name: '',
              data: [],
            },
          ]
          let names = []
          barInfo.forEach((item, index) => {
            if (categories.indexOf(item.code) === -1) {
              categories[categories.length] = item.code
              this.idsCharts.clients[this.idsCharts.clients.length] = {
                code: item.code,
                id: item.id,
              }
            }
            if (names.indexOf(item.name) === -1) {
              names[names.length] = item.name
              index_name = names.length - 1
              arrayColors[index_name] = item.color
              series[index_name] = {
                name: item.name,
                data: [],
              }
              if (this.lastIconClicked == 'types') {
                this.idsCharts[this.lastIconClicked][index_name] = {
                  type: item.name,
                  id: item.type_id,
                }
              }
            }
            index_code = categories.indexOf(item.code)
            index_name = names.indexOf(item.name)
            series[index_name].data[index_code] = Number(item.total)
          })
          if (this.filterBar == 'types') {
            arrayColors = [
              '#257fd9',
              '#25d979',
              '#d9d925',
              '#d93d25',
              '#d025d9',
              '',
            ]
          }
          ApexCharts.exec(
            'review-order-bar',
            'updateOptions',
            {
              series: series,
              colors: arrayColors,
              xaxis: {
                categories: categories,
              },
            },
            false,
            true
          )
        })
        .catch((err) => {
          console.log(err)
        })
    },
    clickStackedSection(e) {
      let selected_client = this.idsCharts.clients.filter((item) => {
        return item.code == e.w.config.xaxis.categories[e.dataPointIndex]
      })
      this.params.client = [selected_client[0].id]
      let selected_status = this.idsCharts.status.filter((item) => {
        return item.label == e.w.config.series[e.seriesIndex].name
      })

      if (this.lastIconClicked == 'status') {
        this.params.status = [selected_status[0].id]
      }
      this.page = 1
      this.getData()
    },
    clickReviewOrderDonut(e) {
      this.params.client = null
      let selected_status = this.idsCharts.status.filter((item) => {
        return item.label == e.w.config.labels[e.dataPointIndex]
      })
      this.params.status = [selected_status[0].id]
      this.page = 1
      this.getData()
    },
    clickTitle() {
      this.params.status = ['1', '2', '4', '5', '6', '7', '8', '9', '11']
      this.params.client = null
      this.params.created = null
      this.page = 1
      this.getData()
    },
    clickTypeIcon() {
      this.lastIconClicked = 'types'
      this.filterBar = this.lastIconClicked
      this.loadBar()
    },
    clickStatusIcon() {
      this.lastIconClicked = 'status'
      this.filterBar = this.lastIconClicked
      this.loadBar()
    },
    getCardsInfo() {
      let params = {}
      reviewOrder.getReviewCards(params).then((res) => {
        let cards = res.data.data
        cards.forEach((item) => {
          switch (item.name) {
            case 'Ready for review':
              this.cards.ready_review = Number(item.total)
              break
            case 'Reviewing':
              this.cards.reviewing = Number(item.total)
              break
            case 'Rejected':
              this.cards.rejected = Number(item.total)
              break
            case 'Approved':
              this.cards.approved = Number(item.total)
              break
            case 'Review at Origin':
              this.cards.review_origin = Number(item.total)
              break
            default:
              break
          }
        })
      })
    },
    clickCard(title) {
      this.params.client = null
      switch (title) {
        case 'ready_review':
          this.params.status = ['4']
          break
        case 'reviewing':
          this.params.status = ['5']
          break
        case 'rejected':
          this.params.status = ['6']
          break
        case 'approved':
          this.params.status = ['8']
          break
        case 'shipped':
          this.params.status = ['10']
          break
        default:
          this.params.status = ['11']
          break
      }
      this.page = 1
      this.getData()
    },
    redirectAddReviewOrder() {
      this.$router.push('/review_orders/create')
    },
    handleFilter() {
      this.loadBar()
      this.loadReviewOrderDonut()
      this.handleSearch()
    },
  },
  mixins: [loading],
  mounted() {
    this.init()
  },
}
</script>

<style>
.title-card-clickeable {
  cursor: pointer;
  padding: 10px;
}

h2.title-card-clickeable:hover {
  color: #bc1300;
}

.custom-card-h-ro {
  height: 480px;
}
</style>